import React from "react";
import PropTypes from "prop-types";
import Teaser from "../Teaser";
import { sizes, srcset } from "../../../helpers/image";
import { exhibitionShape } from "../shapes";

function formatText(location, details, dateRange) {
  return location ? (
    <>
      {location}
      {details ? `, ${details}` : ""} <br />
      {dateRange}
    </>
  ) : (
    dateRange
  );
}

const ExhibitionTeaser = ({ exhibition, onArtistPage, imageWidth, theme }) => {
  const imageSizes = sizes(imageWidth, 3);
  const imageSrcset = srcset(
    imageWidth,
    theme === "overlay"
      ? exhibition.featured_image_retina
      : exhibition.image_retina,
    theme === "overlay"
      ? exhibition.featured_image_default
      : exhibition.image_default
  );
  const isExternal = exhibition.type === "external";
  const displayName = exhibition.display_name
    ? exhibition.display_name
    : exhibition.name;

  return (
    <Teaser
      label={exhibition.label}
      imageSrc={exhibition.image_default}
      imageSrcset={imageSrcset}
      imageSizes={imageSizes}
      imageWidth={imageWidth}
      imageHeight={(imageWidth * 3) / 4}
      imageAlt={exhibition.image_alt}
      heading={displayName}
      url={exhibition.url}
      text={formatText(
        exhibition.location_name,
        exhibition.location_details,
        exhibition.date_range
      )}
      onArtistPage={onArtistPage}
      isExhibition
      isExternal={isExternal}
      theme={theme}
      cta={isExternal ? "View" : null}
    />
  );
};

ExhibitionTeaser.propTypes = {
  exhibition: PropTypes.shape(exhibitionShape).isRequired,
  onArtistPage: PropTypes.bool,
  imageWidth: PropTypes.number,
  theme: PropTypes.string,
};

ExhibitionTeaser.defaultProps = {
  imageWidth: 570,
};

export default ExhibitionTeaser;
